import { B2CloudDay, B3ComfortModeSun } from '@e3dc-react/icons'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import React from 'react'

interface Props {
  hasPv?: boolean
  isGenerating?: boolean
  hasPvError?: boolean
}

const PvStatusIcon: React.FC<Props> = ({ hasPv = false, isGenerating = false, hasPvError = false }) => {
  if (hasPv) {
    return (
      <OptionalTooltipWrapper titleKey={getTooltipText(isGenerating, hasPvError)}>
        <Icon isGenerating={isGenerating} hasPvError={hasPvError} />
      </OptionalTooltipWrapper>
    )
  }

  return null
}

export default PvStatusIcon

const getTooltipText = (isGenerating: boolean, hasPvError: boolean): string => {
  if (isGenerating && hasPvError) return 'installation-status.pv.tooltip-generating-error'
  if (isGenerating) return 'installation-status.pv.tooltip-generating'
  if (hasPvError) return 'installation-status.pv.tooltip-present-error'

  return 'installation-status.pv.tooltip-present'
}

// #region Icon
interface IconProps {
  isGenerating: boolean
  hasPvError: boolean
}

const Icon: React.FC<IconProps> = ({ isGenerating, hasPvError }) => {
  const iconColor = hasPvError ? 'error' : undefined

  if (isGenerating) return <B3ComfortModeSun color={iconColor} />

  return <B2CloudDay color={iconColor} />
}
// #endregion Icon
